/* ==========================================================================
   HALLOWEEN LAYER  (assets/halloween.js)  — v3
   - live countdown for every [data-hw-countdown] element (digits slide on change)
   - glowing heading underlines that draw in once when scrolled into view
   - add-to-cart "pop" + cart-count bump
   - full tier only: scroll progress bar + hero spotlight that follows the mouse
   Nothing floats, falls or flies. Purely visual: never touches forms, the
   cart request or checkout. Motion is skipped for visitors who prefer
   reduced motion (the countdown numbers still update).
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fullTier = html.classList.contains('hw-fx-full');
  var finePointer =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- helpers ---------------------------------------------------------- */
  function flash(node, cls, ms) {
    node.classList.remove(cls);
    void node.offsetWidth; // restart the animation if it is still running
    node.classList.add(cls);
    setTimeout(function () {
      node.classList.remove(cls);
    }, ms);
  }

  /* ---- countdown ------------------------------------------------------- */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setText(root, selector, value, animate) {
    var node = root.querySelector(selector);
    if (!node || node.textContent === value) return;
    node.textContent = value;
    if (animate && !reduceMotion) flash(node, 'hw-tick', 400);
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-hw-countdown]');
    if (!nodes.length) return;
    var now = Date.now();

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      // parse once; "YYYY-MM-DDTHH:MM:SS" without a zone = visitor's local time
      if (el.hwEnd === undefined) {
        var parsed = new Date(el.getAttribute('data-end')).getTime();
        el.hwEnd = isNaN(parsed) ? null : parsed;
      }

      var left = el.hwEnd === null ? -1 : el.hwEnd - now;
      if (left <= 0) {
        el.hidden = true; // offer is over (or the date was invalid): show nothing
        continue;
      }

      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;

      var firstShow = el.hidden; // don't animate the very first paint
      var animate = !firstShow;
      setText(el, '[data-hw-d]', pad(d), animate);
      setText(el, '[data-hw-h]', pad(h), animate);
      setText(el, '[data-hw-m]', pad(m), animate);
      setText(el, '[data-hw-s]', pad(sec), animate);

      var dayUnit = el.querySelector('[data-hw-dayunit]');
      if (dayUnit) dayUnit.hidden = d === 0; // under 24h: drop the days box

      if (firstShow) el.hidden = false;
    }
  }

  tick();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick); // theme editor re-renders

  /* ---- heading underlines: draw in once when visible -------------------- */
  var HEADINGS = 'h1.title, h2.title, .collapsible-content__heading';
  function prepHeadings(scope) {
    var list = (scope || document).querySelectorAll(HEADINGS);
    if (!list.length) return;
    var io =
      !reduceMotion && 'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (en) {
                if (en.isIntersecting) {
                  en.target.classList.add('hw-in');
                  io.unobserve(en.target);
                }
              });
            },
            { threshold: 0.6 }
          )
        : null;

    for (var i = 0; i < list.length; i++) {
      var h = list[i];
      if (h.classList.contains('hw-underline')) continue;
      h.classList.add('hw-underline');
      var align = window.getComputedStyle(h).textAlign;
      if (align === 'center') h.classList.add('hw-ul--center');
      if (io) io.observe(h);
      else h.classList.add('hw-in'); // no observer / reduced motion: just show it
    }
  }
  prepHeadings();
  document.addEventListener('shopify:section:load', function (e) {
    prepHeadings(e.target);
  });

  if (reduceMotion) return;

  /* ---- add-to-cart "pop" ------------------------------------------------ */
  var ATC_SELECTOR =
    '.product-form__submit, .quick-add__submit, .sticky-atc .button, .sticky-atc__button button';

  // capture + passive: never blocks or alters the real add-to-cart click
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target && e.target.closest ? e.target.closest(ATC_SELECTOR) : null;
      if (!target) return;
      if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      flash(target, 'hw-pop', 700);
    },
    { capture: true, passive: true }
  );

  /* ---- cart count bump -------------------------------------------------- */
  // The theme re-renders #cart-icon-bubble after every cart change.
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && window.MutationObserver) {
    new MutationObserver(function () {
      var count = bubble.querySelector('.cart-count-bubble');
      if (count) flash(count, 'hw-bump', 650);
    }).observe(bubble, { childList: true, subtree: true });
  }

  if (!fullTier) return;

  /* ---- scroll progress bar (full tier) ---------------------------------- */
  var bar = document.createElement('div');
  bar.className = 'hw-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var ticking = false;
  function updateBar() {
    var max = html.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, window.pageYOffset / max)) : 0;
    bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    ticking = false;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateBar);
      }
    },
    { passive: true }
  );
  window.addEventListener('resize', updateBar, { passive: true });
  updateBar();

  /* ---- hero spotlight (full tier, mouse only) --------------------------- */
  if (finePointer) {
    var hero = document.querySelector('.hw-hero');
    if (hero) {
      var raf = 0;
      hero.addEventListener(
        'pointermove',
        function (e) {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = 0;
            var r = hero.getBoundingClientRect();
            hero.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
            hero.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
            hero.classList.add('hw-spot-on');
          });
        },
        { passive: true }
      );
      hero.addEventListener('pointerleave', function () {
        hero.classList.remove('hw-spot-on');
      });
    }
  }
})();
